'use strict';

exports.__esModule = true;
// Pads a string with 0's until it is of desired length
var pad = function pad(number, length) {
  if (typeof number === 'undefined') {
    return number;
  }

  // By default, pad to a length of 2
  if (typeof length === 'undefined') {
    length = 2;
  }
  var r = String(number);
  while (r.length < length) {
    r = '0' + r;
  }
  return r;
};

var stringifyArray = function stringifyArray(arry, maxItems, mappingFunction) {
  var aString = '';
  for (var i = 0; i < (arry.length < maxItems ? arry.length : maxItems); i++) {
    aString += mappingFunction(arry[i]) + '^';
  }
  return aString.substring(0, aString.length - 1); // remove trailing ^
};

// Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
var startsWith = function startsWith(base, search, pos) {
  return base.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
};

// Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
var endsWith = function endsWith(base, search, length) {
  if (typeof length === 'undefined' || length > base.length) {
    length = base.length;
  }
  return base.substring(length - search.length, length) === search;
};

exports.endsWith = endsWith;
exports.pad = pad;
exports.stringifyArray = stringifyArray;
exports.startsWith = startsWith;